<svg id="f0aad4ec-447c-4141-900e-55b9b41e6bee" data-name="Layer 1"
    xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40.65 37">
    <g>
        <polygon
            points="40.65 31.12 20.33 37 0 31.12 0 15.56 0 0 20.33 0 40.65 0 40.65 15.56 40.65 31.12"
            fill="#a639b2"></polygon>
        <g>
            <path d="M9.53,12.85l3.6,5.59V12.85h1.53v8.21H13.09L9.37,15.29v5.77H7.83V12.85Z"
                fill="#fff"></path>
            <path d="M21.67,12.85v1.49H17.73v1.85h3.94v1.5H17.73v1.86h3.94v1.51H16.14V12.85Z"
                fill="#fff"></path>
            <path
                d="M24.2,12.85l1.51,5.71,1.71-5.71H29l1.7,5.72,1.54-5.72h1.6l-2.34,8.21H29.88l-1.71-5.79-1.72,5.79h-1.6l-2.28-8.21Z"
                fill="#fff"></path>
        </g>
    </g>
</svg>